<div class="mask d-flex justify-content-center align-items-center">
  <div class="container mt-5 pt-5">
    <section>
      <div class="row">
        <div class="col-12">
          <div class="card z-depth-2">
            <div class="card-body p-0">
              <div class="row mx-0">
                <div class="col-lg-6 py-5 px-md-5 d-none d-lg-block">
                  <div class="view">
                    <img src="../../../../../assets/img/MyPassword.svg" class="img-fluid mt-lg-5" alt="Trakly Reset Password" />
                  </div>
                </div>

                <div class="col-lg-6 col-sm-12 cloudy-knoxville-gradient accent-3 py-5 px-md-5">
                  <form class="text-center border border-light p-5 w-100" (ngSubmit)="SetNewPassword()">
                    <img src="../../../assets/img/Trakly_Logo_3.png" class="img-fluid" alt="TraklyLogo" />
                    <p class="h3 mb-4">Set your password</p>

                    <div *ngIf="!isRegistrationFlow">
                      <p class="text-muted small mb-3" *ngIf="model.email">Resetting password for {{ model.email }}</p>

                      <div class="md-form">
                        <input
                          [(ngModel)]="model.otp"
                          mdbInput
                          mdbValidate
                          name="otp"
                          type="text"
                          id="resetOtp"
                          class="form-control"
                          #otp="ngModel"
                          required
                          maxlength="6"
                          pattern="[0-9]{6}"
                        />
                        <label for="resetOtp">One-time password (6 digits)</label>
                        <mdb-error *ngIf="otp.invalid && (otp.dirty || otp.touched)">
                          Enter the 6-digit code from your email
                        </mdb-error>
                      </div>
                    </div>

                    <!--Password -->
                    <div class="md-form">
                      <input
                        [(ngModel)]="model.password"
                        mdbInput
                        mdbValidate
                        name="password"
                        type="text"
                        id="form7"
                        class="form-control"
                        #password="ngModel"
                        required
                        [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'"
                      />
                      <label for="form7">Password</label>
                      <mdb-error *ngIf="password.invalid && (password.dirty || password.touched)">
                        At lease 8 characters including a number and a uppercase letter
                      </mdb-error>
                      <mdb-success *ngIf="password.valid && (password.dirty || password.touched)"> </mdb-success>
                    </div>

                    <!--Confirm Password -->
                    <div class="md-form">
                      <input
                        [(ngModel)]="model.confirmPassword"
                        mdbInput
                        mdbValidate
                        name="confirmPassword"
                        type="text"
                        id="form8"
                        class="form-control"
                        #confirmPassword="ngModel"
                        required
                        [pattern]="'^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$'"
                      />
                      <label for="form8">Confirm password</label>
                      <mdb-error *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)">
                        At lease 8 characters including a number and a uppercase letter
                      </mdb-error>
                      <mdb-success *ngIf="confirmPassword.valid && (confirmPassword.dirty || confirmPassword.touched)"> </mdb-success>
                    </div>

                    <div *ngIf="showError" class="alert alert-danger" role="alert">
                      {{ errorMsg }}
                    </div>

                    <!--Success Display-->
                    <div *ngIf="showSuccess" class="alert alert-success" role="alert">Password successfully reset. Redirecting you to login...</div>

                    <!-- Sign in button -->
                    <button *ngIf="!busy" mdbBtn color="trakly" block="true" class="my-4" type="submit">Set Password</button>

                    <!--Loading Message display-->
                    <div *ngIf="busy" class="spinner-grow text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
